import { Component } from '@wix/thunderbolt-becky-types'
import { createCompNode, NodeRefs } from '@wix/thunderbolt-catharsis'

const isBuilderComponent = (comp: Component) => comp.componentType.startsWith('platform.builder')

const extractAppDefIdAndWidgetId = (componentType: string) => {
	const appDefIdAndWidgetId = componentType.split('platform.builder.').pop()!
	const appDefinitionId = appDefIdAndWidgetId.split('_')[0]
	const widgetId = appDefIdAndWidgetId.split('_')[1]
	return { appDefinitionId, widgetId }
}

export const widgetIdsNode = createCompNode({
	getDependencies: (component: Component, refs: NodeRefs<{}>) => ({
		compPresets: refs.presetsQuery(component.presetsQuery!),
	}),
	toViewItem: (comp) => {
		if (!isBuilderComponent(comp)) {
			return
		}
		const { widgetId, appDefinitionId } = extractAppDefIdAndWidgetId(comp.componentType)

		return [
			{
				widgetId,
				appDefinitionId,
			},
		]
	},
})
